import { get, isEmpty } from 'radash';

import { DataModelAttribute } from '@/types/DataModel';

const validateMultiDimensionalEntry = <TData>(row: TData, rows: TData[], multiDimensionalAttribute: DataModelAttribute) => {

    const errors = [];

    const areKeysUnique = validateUniqueKeys(row, rows, multiDimensionalAttribute.keyMembers || []);
    if (!areKeysUnique) {
        errors.push('MULTI_DIMENSIONAL.NOT_UNIQUE_VALIDATION_MESSAGE');
    }

    const atLeastOneKeyAttributeProvided = checkAtLeastOnePropertyProvided(row, multiDimensionalAttribute.keyMembers || []);
    if (!atLeastOneKeyAttributeProvided) {
        errors.push('MULTI_DIMENSIONAL.NO_KEYS_VALIDATION_MESSAGE');
    }

    const atLeastOneValueAttributeProvided = checkAtLeastOnePropertyProvided(row, multiDimensionalAttribute.valueMembers || []);
    if (!atLeastOneValueAttributeProvided) {
        errors.push('MULTI_DIMENSIONAL.NO_VALUES_VALIDATION_MESSAGE');
    }

    if (atLeastOneValueAttributeProvided &&
        atLeastOneKeyAttributeProvided &&
        areKeysUnique) {
        return errors;
    } else {
        return errors;
    }
};

const validateUniqueKeys = <TData>(entry: TData, allEntries: TData[], keyMembers: string[] ) => {

    const entriesWithTheSameKeys = allEntries.filter(rowEntry => {
        return multiDimensionalEntriesComparator(entry, rowEntry, keyMembers);
    });

    if (entriesWithTheSameKeys.length > 1) {
        return false;
    } else {
        return true;
    }
};

const multiDimensionalEntriesComparator = <TData>(firstEntry: TData, secondEntry: TData, compareProperties: string[]) => {

    let isEqual = true;
    compareProperties.forEach(property => {
        const firstValue = get<string>(firstEntry, property);
        const secondValue = get<string>(secondEntry, property);

        if (firstValue != secondValue) {
            isEqual = false;
        }
    });
    return isEqual;
};

const checkAtLeastOnePropertyProvided = <TData>(entity: TData, properties: string[]) => {

    let atLeastOnePropProvided = false;
    properties.forEach(property => {
        if (!isEmpty(get(entity, property))) {
            atLeastOnePropProvided = true;
        }
    });

    return atLeastOnePropProvided;
};

export { validateMultiDimensionalEntry };
